import { Component, ElementRef, ViewChild } from '@angular/core';
import { LayoutService } from 'src/app/layout/service/app.layout.service';
import { AppSidebarComponent } from './app.sidebar.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Global } from 'src/global';
import { SeguridadService } from '../services/seguridad.service';
import { MessageService } from 'primeng/api';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { MensajesService } from '../services/mensajes.service';
import { BluetoothPrinterService } from '../services/bluetooth-api/bluetooh-printer.service';

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html'
})

export class AppTopbarComponent {

    currentUser: any;
    iniciales: string;

    showDialogPassword: boolean = false;
    formGroup: FormGroup;
    passType: string = 'password';
    nombreSistema = Global.NOMBRE_SISTEMA;

    @ViewChild('menubutton') menuButton!: ElementRef;
    @ViewChild('searchinput') searchInput!: ElementRef;
    @ViewChild(AppSidebarComponent) appSidebar!: AppSidebarComponent;

    searchActive: boolean = false;
    impresoraStatus: boolean = false;
    mostrarIconoImpresora: boolean = false;
    mostrarBtnCancelar: boolean = true;

    constructor(
        public layoutService: LayoutService,
        public el: ElementRef, 
        private seguridadService: SeguridadService,
        private fb: FormBuilder,
        private messageService: MessageService,
        private mensajesService: MensajesService,
        private authService: AuthService,
        private router: Router,
        public bluetoothPrinterService: BluetoothPrinterService
    ) { 
        this.currentUser = this.seguridadService.getCurrentUser();
        this.setIniciales();
        this.crearFormulario();
        this.mostrarIconoImpresora = this.isMobile();
        this.verificarReseteo();
    }
    
    activateSearch() {
        this.searchActive = true;
        setTimeout(() => {
            this.searchInput.nativeElement.focus();
        }, 100);
    }

    deactivateSearch() {
        this.searchActive = false;
    }
    onMenuButtonClick() {
        this.layoutService.onMenuToggle();
    }

    onConfigButtonClick() {
        this.layoutService.showConfigSidebar();
    }
    
    onSidebarButtonClick() {
        this.layoutService.showSidebar();
    }

    crearFormulario() {
        this.formGroup = this.fb.group({
            oldPassword: [null, Validators.required],
            password1: [null, Validators.required],
            password2: [null, Validators.required]
        });
    }

    setIniciales() {
        const nombres = String(this.currentUser.nombre).split(" ");
        this.iniciales = nombres[0].charAt(0).toUpperCase();
        if ( nombres.length > 1 ){
            this.iniciales += nombres[1].charAt(0).toUpperCase();
        }
    }

    showPassword( passType: string ) {
        this.passType = passType;
    }

    cambiarContrasenha() {
        this.formGroup.reset();
        this.showDialogPassword = true;
    }

    async verificarReseteo() {
        if ( this.currentUser.resetear ) {
            this.mostrarBtnCancelar = false;
            this.showDialogPassword = true;
        }
    }

    async cancelarPass() {
        this.showDialogPassword = false;
        this.formGroup.reset();
    }

    async confirmarPass() {

        const value = this.formGroup.value;
        // controlamos que las nuevas contrasenhas sean iguales
        if ( value.password1 !== value.password2 ) {
            this.messageService.add({key: 'top-right', severity: 'error', summary: 'Favor verificar', detail: 'Las contraseñas no son iguales'});
            return;
        }

        // controlamos que sea de 6 de longitud
        if ( String(value.password1).length < 6 ) {
            this.messageService.add({key: 'top-right', severity: 'error', summary: 'Favor verificar', detail: 'Debe tener un minimo 6 caracteres'});
            return;
        }
        // console.log(this.formGroup.value);
        try {
            const value = this.formGroup.value;
            const res = await this.authService.cambiarContrasenha( this.currentUser.codigo, false, value.password1, value.oldPassword);
            // console.log(res);
            if ( res.ok ) {
                this.messageService.add({key: 'top-right', severity: 'success', summary: 'Contraseña Modificada', detail: 'Lo vamos a redirigir para que vuelva a iniciar sesión'});
                this.showDialogPassword = false;
                setTimeout( async () => {
                    await this.router.navigate(Global.LOGOUT);
                }, 3000);
            } else {
                this.messageService.add({key: 'top-right', severity: 'error', summary: res.msg, detail: res.resp});
            }
        } catch (error: any) {
            this.messageService.add({key: 'top-right', severity: 'error', summary: '', detail: error.message});
            return;
        }
        // this.showDialogPassword = false;
        
    }

    async home() {
        this.router.navigate(Global.DASHBOARD);
    }

    async salir() {
        const resp = await this.mensajesService.preguntar('Salir del Sistema', 'Esta seguro/a que desea salir?');
        if ( resp ) {
            await this.router.navigate(Global.LOGOUT);
        }
    }

    async seleccionarImpresoraBluetooth() {
        try {
            const impresora = await this.bluetoothPrinterService.seleccionarImpresoraBluetooth();
            if (impresora) {
                this.impresoraStatus = true;
            } else {
                this.impresoraStatus = false;
            }
        } catch (error) {
            console.error('Error al seleccionar la impresora:', error);
        }
    }

    async desconectarImpresoraBluetooth(){
        try {
            const resp = await this.mensajesService.preguntar('Desconectar impresora', 'Esta seguro/a que desea Desconectar?');
            if (resp){
                const impresora = await this.bluetoothPrinterService.desconectarImpresora();
                this.messageService.add({key: 'top-right', severity: 'info', summary: '', detail: 'impresora Desconectada' });
                this.impresoraStatus = false;
            }
        } catch (error) {
            
        }
    }

    isMobile() {
        return window.innerWidth <= 991;
    }
}